import { Box, Stack } from "@mui/material";
import {
  AreaColorMap,
  AreaHotkeyMap,
  AreaMaterialsMap,
} from "./scrapEyeLayoutCommon";
import { BayColumn } from "./BayColumn";

/**
 * Bay-style layout (Oklahoma): columns rendered side by side.
 */
export const BayStyleLayout = ({
  columns,
  onSelectArea,
  nonSelectableAreas,
  areaHotkeys,
  areaColors,
  areaMaterials,
  cabLabel,
  selectedArea,
}: {
  columns: readonly (readonly (string | null)[])[];
  onSelectArea?: (area: string) => void;
  nonSelectableAreas: readonly string[];
  areaHotkeys?: AreaHotkeyMap;
  areaColors?: AreaColorMap;
  areaMaterials?: AreaMaterialsMap;
  cabLabel: string;
  selectedArea?: string | null;
}) => (
  <Box
    sx={{
      display: "flex",
      justifyContent: "center",
      gap: 2,
      p: 4,
      bgcolor: "background.default",
      borderRadius: 1,
    }}
  >
    {columns.map((column, index) => (
      <Stack spacing={1} alignItems="center" key={index.toString() + "column"}>
        <BayColumn
          items={column}
          onSelectArea={onSelectArea}
          nonSelectableAreas={nonSelectableAreas}
          areaHotkeys={areaHotkeys}
          areaColors={areaColors}
          areaMaterials={areaMaterials}
          cabLabel={cabLabel}
          selectedArea={selectedArea}
        />
      </Stack>
    ))}
  </Box>
);
